import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import { Box, Modal, Button, Stack, Autocomplete, TextField } from '@mui/material';
import { getFormasPagamento } from './api';
import { cores, labelCampoEscuro } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '70vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw', // Width de 100% para telas de celulares
    height: '70vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center',
};

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const ModalPagamento = React.forwardRef((props, ref) => {
  const [formapagamento, setFormaPagamento] = useState(props.formapagamento || null);
  const [formas, setFormas] = useState([]);

  useEffect(() => {
    fetchFormas();
  }, []);
  const fetchFormas = async () => {
    const result = await getFormasPagamento();
    setFormas(result);
  };


  const onConfirm = () => {
    props.onConfirm(formapagamento);
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <strong style={{ color: cores.textoClaro }}>Selecione a Forma de Pagamento</strong>
        <Autocomplete
          disablePortal
          id="Formas de Pagamento"
          value={formapagamento}
          onChange={(event, newValue) => {
            setFormaPagamento(newValue);
          }}
          options={formas}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          sx={{ width: 400, mb: 2, mt: 3, backgroundColor: 'white', ...labelCampoEscuro }}
          renderInput={(params) => <TextField {...params} label="Forma Pagamento" />}
        />
        <TextField
          id="obs"
          label="Observação"
          variant="outlined"
          value={formapagamento?.obs || ''}
          multiline
          rows={4}
          onChange={(e) => setFormaPagamento({...formapagamento, obs: e.target.value})}
          sx={{ width: '40%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />
        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={5}>
          <Button variant="outlined" onClick={props.onClose} color="error">
            {' '}
            Cancelar
          </Button>
          <Button variant="contained" disabled={!formapagamento} color="success" onClick={onConfirm}>
            Selecionar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

ModalPagamento.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ModalPagamento;